import { createContext, useContext, useEffect, useMemo } from 'react';

type CommissionsNestedDialogsContextValue = {
  setNestedDialogOpen: (isOpen: boolean) => void;
};

const CommissionsNestedDialogsContext = createContext<CommissionsNestedDialogsContextValue | null>(
  null,
);

type Props = {
  children: React.ReactNode;
  setNestedDialogOpen: (isOpen: boolean) => void;
};

export function CommissionsNestedDialogsProvider({
  children,
  setNestedDialogOpen,
}: Props): JSX.Element {
  const value = useMemo<CommissionsNestedDialogsContextValue>(
    () => ({ setNestedDialogOpen }),
    [setNestedDialogOpen],
  );

  return (
    <CommissionsNestedDialogsContext.Provider value={value}>
      {children}
    </CommissionsNestedDialogsContext.Provider>
  );
}

export const useSyncNestedDialogState = (isOpen: boolean): void => {
  const context = useContext(CommissionsNestedDialogsContext);

  useEffect(() => {
    if (!context || !isOpen) {
      return;
    }

    context.setNestedDialogOpen(true);

    return () => {
      context.setNestedDialogOpen(false);
    };
  }, [context, isOpen]);
};
